"use client";

import React, { ReactNode, useState, useEffect } from "react";

interface ClientSideProps {
  children: ReactNode;
}

const ClientSide: React.FC<ClientSideProps> = ({ children }) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return null; // or you could return a loading placeholder here
  }

  return <>{children}</>;
};

export default ClientSide;
